export default __webpack_public_path__ + "static/media/Mindly-Posts.36d55ab5.png";